<script>
  import { onMount } from "svelte";
  import { getScriptSrcFromInitGtm, handleGtagConsent } from "$lib/utilities/gtm";

  export let gtmContainerId = import.meta.env.VITE_GTM_CONTAINER_ID;
  export let gtmDebugParams = import.meta.env.VITE_GTM_DEBUG_PARAMS;
  export let scriptSrc;

  let wait;

  onMount(() => {
    wait = setInterval(() => {
      if (window.oneTrustWrapperHasExecuted && window.vwoHelperHasExecuted) {
        scriptSrc = getScriptSrcFromInitGtm(gtmContainerId)(gtmDebugParams);
        window.OneTrust.OnConsentChanged(handleGtagConsent);
        window.gtmIsInitialized = true;
        clearInterval(wait);
      }
    }, 100);
  });
</script>

<svelte:head>
  {#if scriptSrc}
    <script async src={scriptSrc}></script>
  {/if}
</svelte:head>

<!-- Google Tag Manager (noscript) -->
<noscript>
  <iframe
    title="gtm"
    src="https://www.googletagmanager.com/ns.html?id={gtmContainerId}&{gtmDebugParams}"
    height="0"
    width="0"
    style="display:none;visibility:hidden"
  />
</noscript>
<!-- End Google Tag Manager (noscript) -->
